/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SyncArrows16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M13.216 6.089a.5.5 0 01.568 0l.07.057 2 2 .057.07a.5.5 0 010 .568l-.057.07-.07.057a.5.5 0 01-.568 0l-.07-.057L14 7.706 14 8a6 6 0 01-6 6 5.992 5.992 0 01-4.623-2.181.5.5 0 01.77-.638A4.992 4.992 0 008 13a5 5 0 004.995-4.783L13 8l-.001-.292-1.145 1.146-.07.057a.5.5 0 01-.695-.695l.057-.07 2-2 .07-.057zM8 2a6 6 0 014.616 2.18.5.5 0 11-.77.64A5 5 0 008 3a5 5 0 00-4.995 4.783L3 8v.293l1.146-1.147a.5.5 0 01.638-.057l.07.057a.5.5 0 01.057.638l-.057.07-2 2a.5.5 0 01-.638.057l-.07-.057-2-2a.5.5 0 01.638-.765l.07.057L2 8.293V8a6 6 0 016-6z"
        />
    </AccessibleSVG>
);

export default SyncArrows16;
